import simpleParallax from "simple-parallax-js";

const images = document.getElementsByClassName("parallax-img");
new simpleParallax(images, {
    scale: 1.2,
    customWrapper: ".parallax-container",
});
